import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export enum QUERY_PARAM {
  orgId = 'orgId',
  theme = 'theme',
  email = 'email',
  contactEmail = 'contact.email',
  code = 'code',
  temp_pass = 'temp_pass',
  contactId = 'contactId',
  designId = 'designId',
  origin = 'origin',
  preview = 'preview',
  confirmation_link_token = 'confirmation_link_token'
}

export const useQueryParams = (): URLSearchParams => {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}
